// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"portal_bodyContainer__1otFI"};